import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { Gap } from './layout';
// assets
import { MdPerson } from 'react-icons/md';
import { IoMdChatboxes } from 'react-icons/io';
// types
import { User } from 'types';

const HeaderWrapper = styled(Gap)<{ minimize: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  box-shadow: 0px 5px 12px -1px rgb(0 27 83 / 6%);
  width: calc(100% + 16px);
  margin: 0 -24px;
  padding: 16px;
  background: transparent;
  ${({ minimize }) =>
    minimize &&
    css`
      box-shadow: none;
      background: white;
      width: 56px;
      height: 56px;
      padding: 0;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin: 0;
      margin-left: auto;
    `}
`;

const Paragraph = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.primary[100]};
`;

const Availabilty = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 4px;
  background: rgba(39, 42, 50, 0.05);
  border-radius: 5px;
`;

const AvailabiltyParagraph = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: #4e5461;
`;

const MinimizeIcon = styled.p`
  cursor: pointer;
  font-size: 27px;
  line-height: 0;
  color: rgba(0, 27, 83, 0.6);
  margin: 0;
`;

const ImageWrapper = styled.div<{ unread: boolean }>`
  font-size: 0;
  position: relative;
  ${({ unread }) =>
    unread &&
    css`
      :after {
        content: '';
        width: 6px;
        height: 6px;
        background: #1c6acf;
        position: absolute;
        border-radius: 6px;
        right: 8px;
      }
    `}
`;

interface IConversationHeader {
  advisorDetails: User;
  setMinimize: React.Dispatch<React.SetStateAction<boolean>>;
  minimize: boolean;
  setUnread: React.Dispatch<React.SetStateAction<boolean>>;
  unread: boolean;
}

export const ConversationHeader = ({
  advisorDetails,
  minimize,
  setMinimize,
  setUnread,
  unread,
}: IConversationHeader) => {
  const { colors } = useTheme();
  const advisorFirstName = advisorDetails?.firstName || '';
  const advisorLastName = advisorDetails?.lastName || '';

  // consider extract conversation image and make minimizeComponent
  return (
    <HeaderWrapper minimize={minimize}>
      <Gap style={{ flex: minimize ? 0 : 1 }}>
        <ImageWrapper unread={unread} onClick={() => setMinimize(false)}>
          {!minimize ? (
            <MdPerson size={20} color={colors.primary[100]} />
          ) : (
            <IoMdChatboxes size={32} color={colors.primary[100]} />
          )}
        </ImageWrapper>
        <></>
        {!minimize && (
          <Gap direction='column' gap='6px'>
            <Paragraph>
              {advisorFirstName} {advisorLastName}
            </Paragraph>
            <Availabilty>
              <AvailabiltyParagraph>
                Usually responds in a few hours
              </AvailabiltyParagraph>
            </Availabilty>
          </Gap>
        )}
      </Gap>
      {!minimize && (
        <Gap gap='8px'>
          <MinimizeIcon
            onClick={() => {
              setMinimize(true);
              setUnread(false);
            }}
          >
            _
          </MinimizeIcon>
        </Gap>
      )}
    </HeaderWrapper>
  );
};
